import { render } from "./AccountVerificationView.vue?vue&type=template&id=66549a0e&scoped=true"
import script from "./AccountVerificationView.vue?vue&type=script&lang=js"
export * from "./AccountVerificationView.vue?vue&type=script&lang=js"

import "./AccountVerificationView.vue?vue&type=style&index=0&id=66549a0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66549a0e"]])

export default __exports__